import { z } from 'zod';
import { BaseFlowBlockSchema } from '../block.js';
import { FlowConsumerOfPatientOrderSchema } from '../consumer.js';
import { BaseFlowNotableObjectConfigSchema, FlowNotableObject } from '../notableObject.js';
import { FlowBlockType } from '../type.js';
export const FlowCreateEncounterConfigSchema = BaseFlowNotableObjectConfigSchema.extend({
    notableObject: z.literal(FlowNotableObject.Encounter),
    payload: z.string(),
});
export const FlowCreatePatientConfigSchema = BaseFlowNotableObjectConfigSchema.extend({
    notableObject: z.literal(FlowNotableObject.Patient),
    payload: z.string(),
});
export const FlowCreateServiceReviewSubmissionsSchema = BaseFlowNotableObjectConfigSchema.extend({
    notableObject: z.literal(FlowNotableObject.ServiceReviewSubmissions),
    order: FlowConsumerOfPatientOrderSchema({ isRequired: true }),
    payload: z.string(),
});
export const FlowCreateAuthorizationSubmissionsSchema = BaseFlowNotableObjectConfigSchema.extend({
    notableObject: z.literal(FlowNotableObject.AuthorizationSubmissions),
    order: FlowConsumerOfPatientOrderSchema({ isRequired: true }),
    payload: z.string(),
});
export const FlowCreateNotableObjectConfigSchema = z.discriminatedUnion('notableObject', [
    FlowCreateEncounterConfigSchema,
    FlowCreatePatientConfigSchema,
    FlowCreateServiceReviewSubmissionsSchema,
    FlowCreateAuthorizationSubmissionsSchema,
]);
export const FlowCreateNotableObjectBlockSchema = BaseFlowBlockSchema.extend({
    type: z.literal(FlowBlockType.CreateNotableObject),
    config: FlowCreateNotableObjectConfigSchema,
});
//# sourceMappingURL=config.js.map